export const CREATE_GROUP = 'CREATE_GROUP'
export const UPDATE_GROUP = 'UPDATE_GROUP'
export const FETCH_GROUP = 'FETCH_GROUP'
